import { ProviderFilters } from "../../data-classes";
import { EntityBaseModel } from "./entity-base.model";

export class CompanyModel extends EntityBaseModel {

  protected icon ={
    form: 'building',
    list: 'building'
  }

  setModelData(models:any) {
    models.company.icon = this.icon;

    models.company.modules = ['companies'];

    models.company.form_tabData = {
      entity: models.company.entity,
      entity_type: models.company.entity_type,
      saveEndpoint: models.company.saveEndpoint,
      entity_permissions: models.company.permissions,
      entity_modules:models.company.modules,
      entity_label: models.company.labels.form,
      new_register_dropdowns: ['company', 'protocol', 'protocolaccess', 'mailaccount'],
      edit_register_dropdowns: ['company', 'protocol', 'protocolaccess', 'mailaccount']
    }

    models.company.list_tabData = {
      entity: models.company.entity,
      entity_type: models.company.entity_type,
      entity_label: models.company.labels.form,
      entity_permissions:models.company.permissions,
      entity_modules:models.company.modules,
      listParams: {
        list_entity: models.company.list_entity,
        list_label: models.company.labels.list,
        form_entity: 'company',
        limit: 10,
        headers: [
          'Activo',
          'Sub'+models.company.labels.form,
          'CIF',
          'Nombre',
          'Teléfono',
          'Móvil',
          'Email',
        ],
        fields: [
          { entity: models.company.entity, field: 'enabled', type: 'check' },
          { entity: models.company.entity, field: 'is_subcompanyof_count', type: 'check' },
          { entity: models.company.entity, field: 'cif' },
          { entity: models.company.entity, field: 'name' },
          { entity: models.company.entity, field: 'phone' },
          { entity: models.company.entity, field: 'mobile' },
          { entity: models.company.entity, field: 'email' },
        ],
        filter_firm: false,
        web_access: false,
        disable_user: false,
        filters: new ProviderFilters(models)
    }


    }
  }

}
